import { useState, useEffect } from 'react';

export enum UserAgent {
  ios = 'ios',
  android = 'android',
  desktop = 'desktop',
}

type WindowWithOpera = Window &
  typeof globalThis & {
    opera: any;
  };

const useUserAgent: () => UserAgent | undefined = () => {
  const [userAgent, setUserAgent] = useState<UserAgent>();

  useEffect(() => {
    const ua =
      navigator.userAgent ||
      navigator.vendor ||
      (window as WindowWithOpera).opera;
    if (/android/i.test(ua)) {
      setUserAgent(UserAgent.android);
      return;
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (
      [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod',
      ].includes(navigator.platform) ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    ) {
      setUserAgent(UserAgent.ios);
      return;
    }

    setUserAgent(UserAgent.desktop);
  }, []);

  return userAgent;
};

export default useUserAgent;
